import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {nextRankProgressById} from '/redux/selector/coach.selector';

import ProgressBar from './ProgressBar';

export default connect(
  createStructuredSelector({percent: nextRankProgressById}),
)(ProgressBar);
